import { Button } from '@mui/material';
import PropTypes from 'prop-types';

export const SubmitButton = (props) => {
  const { children, onClick, variant, type, size, sx, fullWidth, disabled, color } = props;

  return (
    <Button
      variant={variant}
      onClick={onClick}
      type={type}
      size={size}
      sx={{
        ...{
          fontWeight: 'bold',
        },
        ...sx,
      }}
      fullWidth={fullWidth}
      disabled={disabled}
      color={color}
    >
      {children}
    </Button>
  );
};

SubmitButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  variant: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  sx: PropTypes.any,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  color: PropTypes.string,
};

SubmitButton.defaultProps = {
  variant: 'contained',
  type: 'submit',
  size: 'large',
  sx: {},
  fullWidth: false,
  onClick: undefined,
  disabled: false,
  color: 'buttonPrimary',
};
